import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureUtmFromSearch } from '../utils/utmAttribution';

// Mount once at the Router root. captureUtmFromSearch is first-touch, so
// firing on every navigation is safe — only the first URL with utm_*
// params gets persisted.
export default function useUtmCapture() {
  const { search } = useLocation();

  useEffect(() => {
    captureUtmFromSearch(search);
  }, [search]);
}
